/* Guide PlumeFit FR (nouveau visuel) : tours de dos 75-100, bonnets
   A-F, toutes les combinaisons existent. Ce modèle se vend directement
   à la taille soutien-gorge (75A, 80B…) : la valeur est la case du
   guide, donc le libellé de la variante Moon Bundle doit s'écrire
   pareil. */
const BRA_SIZE_MAP = {
  "75A": "75A", "80A": "80A", "85A": "85A", "90A": "90A", "95A": "95A", "100A": "100A",
  "75B": "75B", "80B": "80B", "85B": "85B", "90B": "90B", "95B": "95B", "100B": "100B",
  "75C": "75C", "80C": "80C", "85C": "85C", "90C": "90C", "95C": "95C", "100C": "100C",
  "75D": "75D", "80D": "80D", "85D": "85D", "90D": "90D", "95D": "95D", "100D": "100D",
  "75E": "75E", "80E": "80E", "85E": "85E", "90E": "90E", "95E": "95E", "100E": "100E",
  "75F": "75F", "80F": "80F", "85F": "85F", "90F": "90F", "95F": "95F", "100F": "100F"
};

const BAND_OPTIONS = ["75", "80", "85", "90", "95", "100"];
const CUP_OPTIONS = ["A", "B", "C", "D", "E", "F"];

/* Arrondi vers le bas, comme les autres modèles. Le visuel PlumeFit
   ne porte pas la phrase, on garde la règle harmonisée. */
const ROUNDING = "down";
const ROUNDING_TEXT = "Entre deux tailles, prenez la plus petite.";
const PRODUCT_LABEL = "PlumeFit";

let isUpdating = false;
let listboxHider = null;

/* Dernière taille appliquée (quiz ou choix manuel). Sert à remettre
   la même taille sur une offre que Moon Bundle reconstruit ensuite,
   par exemple quand la cliente passe du lot de 2 au lot de 3. */
const MB_QUIZ_APPLIED = { band: "", cup: "" };

function wait(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

function waitFor(fn, timeout, interval) {
  const max = timeout || 600;
  const step = interval || 16;
  return new Promise(resolve => {
    const start = Date.now();
    (function check() {
      const result = fn();
      if (result) return resolve(result);
      if (Date.now() - start >= max) return resolve(null);
      setTimeout(check, step);
    })();
  });
}

function normalizeText(text) {
  return (text || "").replace(/\s+/g, " ").trim().toUpperCase();
}

function hideListboxNode(node) {
  if (!node || node.nodeType !== 1) return;
  const isList =
    (node.matches && node.matches('[role="listbox"], [role="option"], .moonbundle-dropdown-item')) ||
    (node.querySelector && node.querySelector('[role="option"], .moonbundle-dropdown-item'));
  if (!isList) return;
  node.style.setProperty("visibility", "hidden", "important");
  node.style.setProperty("opacity", "0", "important");
  node.style.setProperty("pointer-events", "none", "important");
}

function startHidingListboxes() {
  if (listboxHider) return;
  document.querySelectorAll('[role="listbox"]').forEach(hideListboxNode);
  listboxHider = new MutationObserver(mutations => {
    for (const m of mutations) {
      m.addedNodes.forEach(hideListboxNode);
    }
  });
  listboxHider.observe(document.body, { childList: true, subtree: true });
}

function stopHidingListboxes() {
  if (!listboxHider) return;
  listboxHider.disconnect();
  listboxHider = null;
}

function injectStyles() {
  if (document.getElementById("mb-bra-global-styles")) return;

  const style = document.createElement("style");
  style.id = "mb-bra-global-styles";
  style.textContent = `
    .mb-global-bra-ui{
      position:relative;
      width:100%;
      margin:12px 0 0;
      padding:12px;
      border:1px solid rgba(0,0,0,.14);
      border-radius:12px;
      background:#EAC8BA;
      box-sizing:border-box;
    }

    .mb-global-size-guide-link{
      position:absolute;
      top:12px;
      right:12px;
      z-index:5;
      background:none;
      border:none;
      padding:0;
      margin:0;
      font-size:12px;
      font-weight:600;
      text-decoration:underline;
      cursor:pointer;
      color:#111;
      line-height:1;
    }

    .mb-global-bra-title{
      font-size:14px;
      font-weight:700;
      color:#111;
      line-height:1.2;
      margin-bottom:10px;
      padding-right:120px;
    }

    .mb-global-bra-grid{
      display:grid;
      grid-template-columns:1fr 1fr;
      gap:8px;
      width:100%;
    }

    .mb-global-bra-field{
      position:relative;
      display:flex;
      flex-direction:column;
      gap:4px;
      min-width:0;
    }

    .mb-global-bra-label{
      font-size:11px;
      font-weight:600;
      color:#111;
      line-height:1.2;
    }

    .mb-global-bra-field select{
      width:100%;
      height:36px;
      border:1px solid #111;
      border-radius:8px;
      background:#fff;
      color:#111;
      padding:0 28px 0 10px;
      font-size:13px;
      font-weight:500;
      outline:none;
      appearance:none;
      -webkit-appearance:none;
      box-shadow:none;
      cursor:pointer;
    }

    .mb-global-bra-field::after{
      content:"";
      position:absolute;
      right:10px;
      bottom:13px;
      width:10px;
      height:10px;
      pointer-events:none;
      background:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12'%3E%3Cpath fill='%23000' d='M6 9L1 4h10z'/%3E%3C/svg%3E") no-repeat center;
      background-size:contain;
    }

    .mb-recommended-size-slot{
      display:flex;
      flex-direction:column;
      gap:7px;
      margin-top:10px;
    }

    .mb-size-row{
      display:grid;
      grid-template-columns:26px 1fr;
      align-items:center;
      gap:8px;
      width:100%;
    }

    .mb-size-row-label{
      font-size:12px;
      font-weight:700;
      color:#111;
      opacity:.8;
    }

    .mb-size-row .moonbundle-option-selector{
      width:100% !important;
    }

    .mb-size-row .moonbundle-option-name{
      display:none !important;
    }

    .mb-size-row .moonbundle-dropdown-button{
      width:100% !important;
      height:34px !important;
      min-height:34px !important;
      border-radius:8px !important;
      background:#fff !important;
      position:relative;
      overflow:hidden;
    }

    .mb-global-bra-error{
      color:#b42318;
      font-weight:600;
      font-size:12px;
      margin-top:8px;
    }

    .moonbundle-variant-row{
      margin-bottom:10px !important;
    }

    .moonbundle-variant-selectors{
      display:block !important;
      width:100% !important;
    }

    .moonbundle-swatch-buttons{
      display:flex !important;
      gap:8px !important;
      flex-wrap:wrap !important;
      align-items:center !important;
    }

    .moonbundle-variant-row .moonbundle-variant-selectors > div:nth-child(2):empty{
      display:none !important;
    }

    body.mb-bra-syncing .mb-recommended-size-slot .moonbundle-dropdown-button{
      pointer-events:none;
    }

    body.mb-bra-syncing .mb-recommended-size-slot .moonbundle-dropdown-selected span{
      visibility:hidden;
    }

    body.mb-bra-syncing .mb-recommended-size-slot .moonbundle-dropdown-button::after{
      content:"";
      position:absolute;
      inset:0;
      background:linear-gradient(90deg,transparent,rgba(0,0,0,.07),transparent);
      animation:mb-bra-shimmer .8s linear infinite;
    }

    @keyframes mb-bra-shimmer{
      from{transform:translateX(-100%);}
      to{transform:translateX(100%);}
    }

    .mb-size-guide-modal{
      position:fixed;
      inset:0;
      display:none;
      z-index:99999;
    }

    .mb-size-guide-modal.active{
      display:block;
    }

    .mb-size-guide-overlay{
      position:absolute;
      inset:0;
      background:rgba(0,0,0,.6);
    }

    .mb-size-guide-box{
      position:absolute;
      top:50%;
      left:50%;
      transform:translate(-50%, -50%);
      width:90%;
      max-width:420px;
    }


    .mb-size-guide-box img{
      display:block;
      width:100%;
      border-radius:12px;
    }

    .mb-size-guide-close{
      position:absolute;
      top:8px;
      right:8px;
      width:32px;
      height:32px;
      border:none;
      border-radius:999px;
      background:rgba(0,0,0,.75);
      color:#fff;
      font-size:20px;
      line-height:1;
      cursor:pointer;
      z-index:2;
    }

    @media (max-width:640px){
      .mb-global-bra-field select{
        height:34px;
        font-size:12px;
      }

      .mb-global-size-guide-link{
        font-size:11px;
        top:12px;
        right:12px;
      }

      .mb-global-bra-title{
        padding-right:105px;
      }
    }
  `;
  document.head.appendChild(style);
}

function injectSizeGuideModal() {
  if (document.getElementById("mb-size-guide-modal")) return;

  const modal = document.createElement("div");
  modal.id = "mb-size-guide-modal";
  modal.className = "mb-size-guide-modal";
  modal.innerHTML = `
    <div class="mb-size-guide-overlay"></div>
    <div class="mb-size-guide-box">
      <button type="button" class="mb-size-guide-close" aria-label="Fermer">×</button>
      <img src="https://cdn.shopify.com/s/files/1/0783/0978/5927/files/FINALPLUMEFIT_1.jpg?v=1791635803" alt="Guide des tailles PlumeFit">
    </div>
  `;
  document.body.appendChild(modal);

  modal.querySelector(".mb-size-guide-close").addEventListener("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    modal.classList.remove("active");
  });

  modal.querySelector(".mb-size-guide-overlay").addEventListener("click", function () {
    modal.classList.remove("active");
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") modal.classList.remove("active");
  });
}

function openSizeGuideModal(e) {
  if (e) {
    e.preventDefault();
    e.stopPropagation();
  }

  const modal = document.getElementById("mb-size-guide-modal");
  if (modal) modal.classList.add("active");
}

function findOption(dropdownRoot, targetValue) {
  const target = normalizeText(targetValue);
  const scoped = Array.from(
    dropdownRoot.querySelectorAll('[role="option"], .moonbundle-dropdown-item')
  );
  let match = scoped.find(el => normalizeText(el.textContent) === target);
  if (match) return match;

  const global = Array.from(
    document.querySelectorAll('[role="option"], .moonbundle-dropdown-item')
  );
  return global.find(el => normalizeText(el.textContent) === target) || null;
}

function readMoonbundleDropdownValue(dropdownRoot) {
  if (!dropdownRoot) return "";
  const span = dropdownRoot.querySelector(".moonbundle-dropdown-selected span");
  return normalizeText(span && span.textContent);
}

async function selectMoonbundleDropdownValue(dropdownRoot, targetValue) {
  if (!dropdownRoot || !targetValue) return false;

  const button = dropdownRoot.querySelector(".moonbundle-dropdown-button");
  if (!button) return false;

  const target = normalizeText(targetValue);
  const getCurrent = () => readMoonbundleDropdownValue(dropdownRoot);

  if (getCurrent() === target) return true;

  button.click();

  const match = await waitFor(() => findOption(dropdownRoot, targetValue), 600, 16);

  if (!match) {
    document.body.click();
    return false;
  }

  match.click();

  await waitFor(() => getCurrent() === target, 400, 16);

  return getCurrent() === target;
}

function getVariantRowsFromOffer(offer) {
  if (!offer) return [];
  return Array.from(offer.querySelectorAll(".moonbundle-variant-row"));
}

function moveAllSizeSelectorsIntoBox(offer) {
  const slot = offer.querySelector(".mb-recommended-size-slot");
  if (!slot) return;

  const rows = getVariantRowsFromOffer(offer);
  if (!rows.length) return;

  rows.forEach((row, index) => {
    if (slot.querySelector(`[data-mb-size-row="${index + 1}"]`)) return;

    const selectors = row.querySelectorAll(".moonbundle-option-selector");
    if (selectors.length < 2) return;

    const sizeSelector = selectors[selectors.length - 1];
    sizeSelector.classList.add("mb-moved-size-selector");

    const wrapper = document.createElement("div");
    wrapper.className = "mb-size-row";
    wrapper.setAttribute("data-mb-size-row", String(index + 1));

    const label = document.createElement("div");
    label.className = "mb-size-row-label";
    label.textContent = `#${index + 1}`;

    wrapper.appendChild(label);
    wrapper.appendChild(sizeSelector);
    slot.appendChild(wrapper);
  });
}

/* Renvoie true quand chaque exemplaire de l'offre affiche bien la
   taille produit correspondant à band+cup, false sinon (ou si un
   autre passage était encore en cours). Le quiz s'appuie sur ce
   retour pour vérifier, pas seulement pour lancer. */
async function applyMappedSizeToOffer(offer, band, cup, errorEl) {
  if (!offer || isUpdating) return false;

  isUpdating = true;
  document.body.classList.add("mb-bra-syncing");
  startHidingListboxes();

  try {
    if (errorEl) errorEl.innerHTML = "";

    if (!band || !cup) return false;

    const mappedSize = BRA_SIZE_MAP[`${band}${cup}`];

    if (!mappedSize) {
      if (errorEl) {
        errorEl.innerHTML = `<span class="mb-global-bra-error">Cette combinaison n’est pas disponible</span>`;
      }
      return false;
    }

    moveAllSizeSelectorsIntoBox(offer);

    const dropdowns = Array.from(
      offer.querySelectorAll(".mb-recommended-size-slot .moonbundle-custom-dropdown")
    );

    let allOk = dropdowns.length > 0;

    for (const dropdown of dropdowns) {
      let ok = await selectMoonbundleDropdownValue(dropdown, mappedSize);

      /* Moon Bundle peut refermer la liste ou reconstruire la ligne
         entre deux clics : un second essai suffit en général. */
      if (!ok) {
        await wait(120);
        ok = await selectMoonbundleDropdownValue(dropdown, mappedSize);
      }

      if (!ok) allOk = false;
    }

    if (!allOk && errorEl) {
      errorEl.innerHTML = `<span class="mb-global-bra-error">Impossible de sélectionner automatiquement la taille</span>`;
    }

    return allOk;
  } finally {
    stopHidingListboxes();
    document.body.classList.remove("mb-bra-syncing");
    isUpdating = false;
  }
}

function buildGlobalSelectorUI(offer) {
  const ui = document.createElement("div");
  ui.className = "mb-global-bra-ui";

  ui.innerHTML = `
    <button type="button" class="mb-global-size-guide-link">Guide des tailles</button>
    <div class="mb-global-bra-title">Choisissez votre taille</div>

    <div class="mb-global-bra-grid">
      <div class="mb-global-bra-field">
        <div class="mb-global-bra-label">Tour de dos</div>
        <select class="mb-global-band">
          <option value="">Tour de dos</option>
          ${BAND_OPTIONS.map(v => `<option value="${v}">${v}</option>`).join("")}
        </select>
      </div>

      <div class="mb-global-bra-field">
        <div class="mb-global-bra-label">Bonnet</div>
        <select class="mb-global-cup">
          <option value="">Bonnet</option>
          ${CUP_OPTIONS.map(v => `<option value="${v}">${v}</option>`).join("")}
        </select>
      </div>
    </div>

    <div class="mb-recommended-size-slot"></div>
    <div class="mb-global-bra-error-wrap"></div>
  `;

  const bandSelect = ui.querySelector(".mb-global-band");
  const cupSelect = ui.querySelector(".mb-global-cup");
  const errorEl = ui.querySelector(".mb-global-bra-error-wrap");
  const sizeGuideBtn = ui.querySelector(".mb-global-size-guide-link");

  /* Comme sur MinimaBra, on ne propose que les tailles qui existent :
     une fois le bonnet choisi, les tours de dos sans case au guide
     disparaissent de la liste (et inversement), au lieu d'afficher
     « combinaison non disponible » après coup. */
  const syncAvailability = () => {
    const band = bandSelect.value;
    const cup = cupSelect.value;
    Array.from(bandSelect.options).forEach(o => {
      if (!o.value) return;
      const off = !!cup && !BRA_SIZE_MAP[o.value + cup];
      o.disabled = off;
      o.hidden = off;
    });
    Array.from(cupSelect.options).forEach(o => {
      if (!o.value) return;
      const off = !!band && !BRA_SIZE_MAP[band + o.value];
      o.disabled = off;
      o.hidden = off;
    });
  };

  const onChange = () => {
    syncAvailability();
    /* Un choix manuel remplace le résultat du quiz pour la suite. */
    if (bandSelect.value && cupSelect.value) {
      MB_QUIZ_APPLIED.band = bandSelect.value;
      MB_QUIZ_APPLIED.cup = cupSelect.value;
    }
    applyMappedSizeToOffer(offer, bandSelect.value, cupSelect.value, errorEl);
  };

  bandSelect.addEventListener("change", onChange);
  cupSelect.addEventListener("change", onChange);
  bandSelect.addEventListener("focus", syncAvailability);
  cupSelect.addEventListener("focus", syncAvailability);
  syncAvailability();
  sizeGuideBtn.addEventListener("click", openSizeGuideModal);

  return ui;
}

function injectGlobalSelectorIntoOffer(offer) {
  if (!offer || offer.querySelector(".mb-global-bra-ui")) return;

  const variantsBox = offer.querySelector(".moonbundle-variants-box");
  if (!variantsBox) return;

  const rows = getVariantRowsFromOffer(offer);
  if (!rows.length) return;

  const ui = buildGlobalSelectorUI(offer);

  variantsBox.appendChild(ui);
  moveAllSizeSelectorsIntoBox(offer);
}

function initGlobalBraSelectors() {
  injectStyles();
  mbQuizInjectStyles();
  injectSizeGuideModal();
  mbQuizInjectTrigger();

  document.querySelectorAll(".moonbundle-option-wrapper").forEach(offer => {
    injectGlobalSelectorIntoOffer(offer);
    moveAllSizeSelectorsIntoBox(offer);
  });

  /* Une offre que Moon Bundle vient de (re)construire repart de zéro :
     si la cliente a déjà choisi une taille (quiz ou à la main), on la
     lui remet, sans qu'elle ait à refaire le quiz. */
  mbQuizReapplyToFreshOffers();
}

initGlobalBraSelectors();

const observer = new MutationObserver(() => {
  initGlobalBraSelectors();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});


/* ============================================================
   Celyssia — « Trouvez votre taille parfaite »
   Quiz de taille en 4 questions.

   À COLLER dans le Custom JavaScript de Moon Bundle,
   APRÈS tout le code existant (tout à la fin du champ).

   Réutilise BRA_SIZE_MAP, BAND_OPTIONS, CUP_OPTIONS, ROUNDING
   et ROUNDING_TEXT déclarés en haut du fichier.
   ============================================================ */

const MB_QUIZ_STATE = {
  band: "",
  cup: "",
  cupFit: "",
  bandFit: "",
  hooks: "",
  step: 1
};

/* ---------- logique de correction ---------- */

function mbQuizResolveSize() {
  const bandIdx = BAND_OPTIONS.indexOf(MB_QUIZ_STATE.band);
  const cupIdx = CUP_OPTIONS.indexOf(MB_QUIZ_STATE.cup);
  if (bandIdx === -1 || cupIdx === -1) return null;

  /* Bande : rangée la plus serrée = la bande est déjà au maximum,
     donc trop large. Rangée la plus large = l'inverse. */
  let bandDelta = 0;
  if (MB_QUIZ_STATE.bandFit === "tight") bandDelta += 1;
  if (MB_QUIZ_STATE.bandFit === "loose") bandDelta -= 1;
  if (MB_QUIZ_STATE.hooks === "closest") bandDelta -= 1;
  if (MB_QUIZ_STATE.hooks === "farthest") bandDelta += 1;

  if (bandDelta > 1) bandDelta = 1;
  if (bandDelta < -1) bandDelta = -1;

  /* Taille sœur : une bande plus étroite demande un bonnet plus grand
     pour le même volume. */
  let cupDelta = -bandDelta;
  if (MB_QUIZ_STATE.cupFit === "small") cupDelta += 1;
  if (MB_QUIZ_STATE.cupFit === "big") cupDelta -= 1;

  let newBandIdx = bandIdx + bandDelta;
  let newCupIdx = cupIdx + cupDelta;

  if (newBandIdx < 0) newBandIdx = 0;
  if (newBandIdx > BAND_OPTIONS.length - 1) newBandIdx = BAND_OPTIONS.length - 1;
  if (newCupIdx < 0) newCupIdx = 0;
  if (newCupIdx > CUP_OPTIONS.length - 1) newCupIdx = CUP_OPTIONS.length - 1;

  const band = BAND_OPTIONS[newBandIdx];
  const cup = CUP_OPTIONS[newCupIdx];

  /* Si la case n'existe pas au tableau, on suit le sens du produit
     (ROUNDING) : "up" = on monte le bonnet d'abord, "down" = on
     descend d'abord. L'autre sens sert de second recours, pour ne
     jamais laisser la cliente sur « aucune correspondance ». */
  let shapelift = BRA_SIZE_MAP[band + cup];
  let resolvedCup = cup;

  const dir = ROUNDING === "down" ? -1 : 1;

  for (let i = newCupIdx + dir; i >= 0 && i < CUP_OPTIONS.length && !shapelift; i += dir) {
    shapelift = BRA_SIZE_MAP[band + CUP_OPTIONS[i]];
    if (shapelift) resolvedCup = CUP_OPTIONS[i];
  }

  for (let i = newCupIdx - dir; i >= 0 && i < CUP_OPTIONS.length && !shapelift; i -= dir) {
    shapelift = BRA_SIZE_MAP[band + CUP_OPTIONS[i]];
    if (shapelift) resolvedCup = CUP_OPTIONS[i];
  }

  /* La taille affichée doit exister au guide : si la cliente la
     vérifie, elle ne doit pas tomber sur une case vide. */
  const cupAdjusted = resolvedCup !== cup;
  cupDelta = CUP_OPTIONS.indexOf(resolvedCup) - cupIdx;

  return {
    band: band,
    cup: resolvedCup,
    shapelift: shapelift || "",
    bandDelta: bandDelta,
    cupDelta: cupDelta,
    cupAdjusted: cupAdjusted,
    originalBand: MB_QUIZ_STATE.band,
    originalCup: MB_QUIZ_STATE.cup
  };
}

function mbQuizReasons(result) {
  const out = [];

  /* Les textes commencent en minuscule : ils suivent un deux-points. */

  if (result.bandDelta !== 0) {
    let why;
    if (result.bandDelta < 0) {
      why = MB_QUIZ_STATE.hooks === "closest"
        ? "vous le portez déjà sur la rangée la plus serrée. La bande ne peut plus se resserrer, et elle se détendra encore avec le temps."
        : "vous nous avez dit qu’elle remonte dans le dos.";
    } else {
      why = MB_QUIZ_STATE.bandFit === "tight"
        ? "vous nous avez dit qu’elle serre trop."
        : "vous l’attachez déjà sur la rangée la plus large, il ne reste plus de marge.";
    }
    out.push({
      label: "Tour de dos " + result.originalBand + " \u2192 " + result.band,
      text: why
    });
  }

  if (result.cupDelta !== 0 || result.cupAdjusted) {
    let why;
    if (result.cupAdjusted) {
      why = "ce bonnet n’existe pas sur ce tour de dos dans notre gamme, nous prenons le plus proche du guide.";
    } else if (MB_QUIZ_STATE.cupFit === "small") {
      why = "vous nous avez dit que la poitrine débordait.";
    } else if (MB_QUIZ_STATE.cupFit === "big") {
      why = "vous nous avez dit que le bonnet bâillait.";
    } else if (result.bandDelta < 0) {
      why = "une bande plus étroite demande un bonnet plus grand, à volume égal. Votre poitrine ne change pas, c’est la structure qui se resserre.";
    } else {
      why = "une bande plus large demande un bonnet plus petit, à volume égal. Votre poitrine ne change pas, c’est la structure qui s’élargit.";
    }
    out.push({
      label: "Bonnet " + result.originalCup + " \u2192 " + result.cup,
      text: why
    });
  }

  if (!out.length) {
    out.push({
      label: "Taille confirmée",
      text: "votre soutien-gorge actuel vous va bien, nous gardons la même correspondance."
    });
  }

  return out;
}

/* ---------- interface ---------- */

function mbQuizInjectStyles() {
  if (document.getElementById("mb-quiz-styles")) return;

  const style = document.createElement("style");
  style.id = "mb-quiz-styles";
  style.textContent = `
    .mb-quiz-open{
      background:none;border:0;padding:0;margin:0;
      font-size:13px;font-weight:600;color:#111;
      text-decoration:underline;cursor:pointer;line-height:1.2;
    }
    .mb-quiz-bar{
      display:flex;justify-content:space-between;align-items:center;
      gap:12px;margin:0 0 14px;padding:0 2px;
    }
    .mb-quiz-bar .mb-quiz-open{font-size:14px;}
    .mb-quiz-bar .mb-quiz-guide{font-weight:500;color:#4A342C;}
    .mb-quiz-modal{position:fixed;inset:0;display:none;z-index:100000;}
    .mb-quiz-modal.active{display:block;}
    .mb-quiz-overlay{position:absolute;inset:0;background:rgba(0,0,0,.55);}
    .mb-quiz-box{
      position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);
      width:92%;max-width:430px;max-height:88vh;overflow-y:auto;
      background:#FBF9F7;border-radius:16px;padding:22px 20px 20px;
      box-sizing:border-box;
      font-family:inherit;color:#1C1310;
    }
    .mb-quiz-steps{display:flex;gap:5px;margin-bottom:16px;}
    .mb-quiz-steps span{flex:1;height:3px;border-radius:2px;background:#E2D8D1;}
    .mb-quiz-steps span.done{background:#1C1310;}
    .mb-quiz-close{
      position:absolute;top:14px;right:14px;width:30px;height:30px;
      border:0;border-radius:999px;background:none;color:#6B5A52;
      font-size:22px;line-height:1;cursor:pointer;
    }
    .mb-quiz-count{font-size:12px;color:#8A7168;margin:0 0 6px;}
    .mb-quiz-q{font-size:21px;font-weight:700;line-height:1.25;margin:0 0 6px;}
    .mb-quiz-sub{font-size:13.5px;color:#6B5A52;margin:0 0 16px;line-height:1.4;}
    .mb-quiz-label{font-size:12px;color:#6B5A52;margin:0 0 7px;}
    .mb-quiz-grid{display:grid;gap:7px;margin-bottom:16px;}
    .mb-quiz-grid.bands{grid-template-columns:repeat(5,1fr);}
    .mb-quiz-grid.cups{grid-template-columns:repeat(4,1fr);}
    .mb-quiz-chip{
      appearance:none;border:1px solid #DED5CE;background:#fff;
      border-radius:9px;padding:10px 2px;font:inherit;font-size:13px;
      cursor:pointer;color:#1C1310;transition:background .12s,border-color .12s;
    }
    .mb-quiz-chip[aria-pressed="true"]{background:#1C1310;border-color:#1C1310;color:#fff;font-weight:600;}
    .mb-quiz-opt{
      display:flex;gap:11px;align-items:flex-start;width:100%;text-align:left;
      border:1px solid #DED5CE;background:#fff;border-radius:11px;
      padding:13px 14px;margin-bottom:8px;cursor:pointer;font:inherit;
    }
    .mb-quiz-opt[aria-pressed="true"]{border-color:#1C1310;border-width:2px;padding:12px 13px;}
    .mb-quiz-dot{
      flex:0 0 auto;width:17px;height:17px;border-radius:50%;
      border:1.5px solid #C4B7AE;margin-top:2px;position:relative;
    }
    .mb-quiz-opt[aria-pressed="true"] .mb-quiz-dot{border-color:#1C1310;}
    .mb-quiz-opt[aria-pressed="true"] .mb-quiz-dot::after{
      content:"";position:absolute;inset:3px;border-radius:50%;background:#1C1310;
    }
    .mb-quiz-opt b{display:block;font-size:14.5px;font-weight:700;margin-bottom:2px;}
    .mb-quiz-opt span.d{display:block;font-size:12.5px;color:#6B5A52;line-height:1.35;}
    .mb-quiz-nav{display:flex;align-items:center;gap:12px;margin-top:16px;}
    .mb-quiz-back{
      background:none;border:0;padding:6px 2px;font:inherit;font-size:13.5px;
      color:#6B5A52;cursor:pointer;
    }
    .mb-quiz-next{
      flex:1;appearance:none;border:0;border-radius:10px;
      background:#1C1310;color:#fff;font:inherit;font-size:15px;font-weight:600;
      padding:14px;cursor:pointer;
    }
    .mb-quiz-next[disabled]{background:#D8CCC4;color:#fff;cursor:default;}
    .mb-quiz-result{text-align:center;}
    .mb-quiz-result .cap{font-size:14px;color:#6B5A52;margin:0 0 14px;}
    .mb-quiz-size{
      border:1px dashed #C4B7AE;border-radius:10px;
      padding:22px 12px;margin:0 auto 14px;max-width:270px;background:#fff;
    }
    .mb-quiz-size .brand{font-size:12.5px;color:#8A7168;margin:0 0 8px;}
    .mb-quiz-size .val{font-size:46px;font-weight:700;line-height:1;margin:0;letter-spacing:-.01em;}
    .mb-quiz-size .garment{font-size:13px;color:#6B5A52;margin:10px 0 0;}
    .mb-quiz-size .garment b{color:#1C1310;font-weight:700;}
    .mb-quiz-result .spec{font-size:13.5px;color:#6B5A52;margin:0;}
    .mb-quiz-result .spec b{color:#1C1310;font-weight:700;}
    .mb-quiz-why{
      text-align:left;border-top:1px solid #E7DDD6;
      margin-top:18px;padding-top:16px;
    }
    .mb-quiz-why h4{font-size:14px;color:#6B5A52;font-weight:500;margin:0 0 12px;}
    .mb-quiz-why ul{list-style:none;margin:0;padding:0;}
    .mb-quiz-why li{
      position:relative;padding-left:16px;margin:0 0 12px;
      font-size:13.5px;line-height:1.5;color:#4A342C;
    }
    .mb-quiz-why li::before{
      content:"";position:absolute;left:0;top:10px;
      width:8px;height:1.5px;background:#A8968C;
    }
    .mb-quiz-why li b{color:#1C1310;font-weight:700;}
    .mb-quiz-why .rule{
      margin:14px 0 0;font-size:12.5px;color:#8A7168;font-style:italic;
    }
    .mb-quiz-result .mb-quiz-next{width:100%;margin-top:18px;}
    .mb-quiz-restart{
      display:block;margin:14px auto 0;background:none;border:0;
      font:inherit;font-size:13.5px;color:#6B5A52;text-decoration:underline;cursor:pointer;
    }
    @media (max-width:400px){
      .mb-quiz-grid.cups{grid-template-columns:repeat(4,1fr);}
      .mb-quiz-grid.bands{grid-template-columns:repeat(4,1fr);}
      .mb-quiz-q{font-size:19px;}
    }
  `;
  document.head.appendChild(style);
}

function mbQuizModal() {
  let modal = document.getElementById("mb-quiz-modal");
  if (modal) return modal;

  modal = document.createElement("div");
  modal.id = "mb-quiz-modal";
  modal.className = "mb-quiz-modal";
  modal.innerHTML =
    '<div class="mb-quiz-overlay"></div>' +
    '<div class="mb-quiz-box" role="dialog" aria-modal="true">' +
      '<button type="button" class="mb-quiz-close" aria-label="Fermer">&times;</button>' +
      '<div class="mb-quiz-body"></div>' +
    '</div>';
  document.body.appendChild(modal);

  modal.querySelector(".mb-quiz-close").addEventListener("click", mbQuizClose);
  modal.querySelector(".mb-quiz-overlay").addEventListener("click", mbQuizClose);
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") mbQuizClose();
  });

  return modal;
}

function mbQuizClose() {
  const modal = document.getElementById("mb-quiz-modal");
  if (modal) modal.classList.remove("active");
}

function mbQuizOpen() {
  mbQuizInjectStyles();
  const modal = mbQuizModal();
  MB_QUIZ_STATE.step = 1;
  modal.classList.add("active");
  mbQuizRender();
}

function mbQuizStepsBar(step) {
  let out = '<div class="mb-quiz-steps">';
  for (let i = 1; i <= 4; i++) {
    out += '<span class="' + (i <= step ? "done" : "") + '"></span>';
  }
  return out + "</div>";
}

function mbQuizRender() {
  const modal = mbQuizModal();
  const body = modal.querySelector(".mb-quiz-body");
  const s = MB_QUIZ_STATE;

  if (s.step === 1) {
    body.innerHTML =
      mbQuizStepsBar(1) +
      '<p class="mb-quiz-count">Question 1 / 4</p>' +
      '<p class="mb-quiz-q">Quelle taille portez-vous actuellement&nbsp;?</p>' +
      '<p class="mb-quiz-sub">Pensez au soutien-gorge dans lequel vous êtes le plus à l’aise.</p>' +
      '<p class="mb-quiz-label">Tour de dos</p>' +
      '<div class="mb-quiz-grid bands">' +
        BAND_OPTIONS.map(function (v) {
          return '<button type="button" class="mb-quiz-chip" data-band="' + v + '" aria-pressed="' + (s.band === v) + '">' + v + '</button>';
        }).join("") +
      '</div>' +
      '<p class="mb-quiz-label">Bonnet</p>' +
      '<div class="mb-quiz-grid cups">' +
        CUP_OPTIONS.map(function (v) {
          return '<button type="button" class="mb-quiz-chip" data-cup="' + v + '" aria-pressed="' + (s.cup === v) + '">' + v + '</button>';
        }).join("") +
      '</div>' +
      '<div class="mb-quiz-nav"><button type="button" class="mb-quiz-next" data-next ' +
        (s.band && s.cup ? "" : "disabled") + '>Continuer</button></div>';
  }

  if (s.step === 2) {
    body.innerHTML =
      mbQuizStepsBar(2) +
      '<p class="mb-quiz-count">Question 2 / 4</p>' +
      '<p class="mb-quiz-q">Comment le bonnet vous va-t-il&nbsp;?</p>' +
      '<p class="mb-quiz-sub">Toujours le même soutien-gorge qu’à la question 1.</p>' +
      mbQuizOption("cupFit", "small", "Trop petit", "La poitrine déborde par le haut ou sur les côtés.") +
      mbQuizOption("cupFit", "perfect", "Parfait", "Ni vide, ni débordement.") +
      mbQuizOption("cupFit", "big", "Trop grand", "Le bonnet bâille ou fait des plis.") +
      mbQuizNav(s.cupFit);
  }

  if (s.step === 3) {
    body.innerHTML =
      mbQuizStepsBar(3) +
      '<p class="mb-quiz-count">Question 3 / 4</p>' +
      '<p class="mb-quiz-q">Comment la bande sous la poitrine vous tient-elle&nbsp;?</p>' +
      '<p class="mb-quiz-sub">C’est elle qui assure l’essentiel du maintien.</p>' +
      mbQuizOption("bandFit", "tight", "Trop serrée", "Elle marque la peau ou comprime.") +
      mbQuizOption("bandFit", "perfect", "Parfaite", "Elle reste bien horizontale, sans bouger.") +
      mbQuizOption("bandFit", "loose", "Trop lâche", "Elle remonte dans le dos.") +
      mbQuizNav(s.bandFit);
  }

  if (s.step === 4) {
    body.innerHTML =
      mbQuizStepsBar(4) +
      '<p class="mb-quiz-count">Question 4 / 4</p>' +
      '<p class="mb-quiz-q">Sur quelle rangée d’agrafes l’attachez-vous&nbsp;?</p>' +
      '<p class="mb-quiz-sub">Cela nous dit s’il vous reste de la marge.</p>' +
      mbQuizOption("hooks", "closest", "La plus serrée", "Celle qui serre le plus.") +
      mbQuizOption("hooks", "medium", "Au milieu", "La rangée du milieu.") +
      mbQuizOption("hooks", "farthest", "La plus large", "Celle qui serre le moins.") +
      mbQuizNav(s.hooks, "Voir ma taille");
  }

  if (s.step === 5) {
    const result = mbQuizResolveSize();

    if (!result || !result.shapelift) {
      body.innerHTML =
        '<div class="mb-quiz-result"><p class="mb-quiz-q">Aucune correspondance trouvée</p>' +
        '<p class="mb-quiz-sub">Consultez le guide des tailles ou écrivez-nous, nous trouverons votre taille avec vous.</p>' +
        '<button type="button" class="mb-quiz-restart" data-restart>Recommencer</button></div>';
      mbQuizBind(body);
      return;
    }

    body.innerHTML =
      '<div class="mb-quiz-result">' +
        '<p class="cap">Votre taille recommandée</p>' +
        '<div class="mb-quiz-size">' +
          '<p class="brand">Celyssia</p>' +
          '<p class="val">' + result.band + result.cup + '</p>' +
          /* PlumeFit se vend à la taille soutien-gorge : on n'affiche la
             ligne « Taille produit » que si elle diffère du 95D au-dessus. */
          (result.shapelift !== result.band + result.cup
            ? '<p class="garment">Taille ' + PRODUCT_LABEL + '&nbsp;: <b>' + result.shapelift + '</b></p>'
            : '') +
        '</div>' +
        '<p class="spec">Vous nous avez indiqué du <b>' + result.originalBand + result.originalCup + '</b>.</p>' +
        '<div class="mb-quiz-why"><h4>Pourquoi cette taille&nbsp;?</h4><ul>' +
          mbQuizReasons(result).map(function (r) {
            return '<li><b>' + r.label + '</b>&nbsp;: ' + r.text + '</li>';
          }).join("") +
        '</ul>' +
        (ROUNDING_TEXT ? '<p class="rule">' + ROUNDING_TEXT + '</p>' : '') +
        '</div>' +
        '<button type="button" class="mb-quiz-next" data-apply>Choisir cette taille</button>' +
        '<button type="button" class="mb-quiz-restart" data-restart>Recommencer</button>' +
      '</div>';
  }

  mbQuizBind(body);
}

function mbQuizOption(field, value, title, desc) {
  const on = MB_QUIZ_STATE[field] === value;
  return '<button type="button" class="mb-quiz-opt" data-field="' + field + '" data-value="' + value + '" aria-pressed="' + on + '">' +
    '<span class="mb-quiz-dot"></span><span><b>' + title + '</b>' +
    (desc ? '<span class="d">' + desc + '</span>' : "") + '</span></button>';
}

function mbQuizNav(value, label) {
  return '<div class="mb-quiz-nav">' +
    '<button type="button" class="mb-quiz-back" data-back>Retour</button>' +
    '<button type="button" class="mb-quiz-next" data-next ' + (value ? "" : "disabled") + '>' +
    (label || "Continuer") + '</button></div>';
}

function mbQuizBind(body) {
  body.querySelectorAll("[data-band]").forEach(function (el) {
    el.addEventListener("click", function () {
      MB_QUIZ_STATE.band = el.getAttribute("data-band");
      mbQuizRender();
    });
  });

  body.querySelectorAll("[data-cup]").forEach(function (el) {
    el.addEventListener("click", function () {
      MB_QUIZ_STATE.cup = el.getAttribute("data-cup");
      mbQuizRender();
    });
  });

  body.querySelectorAll("[data-field]").forEach(function (el) {
    el.addEventListener("click", function () {
      MB_QUIZ_STATE[el.getAttribute("data-field")] = el.getAttribute("data-value");
      mbQuizRender();
    });
  });

  const next = body.querySelector("[data-next]");
  if (next) next.addEventListener("click", function () {
    MB_QUIZ_STATE.step += 1;
    mbQuizRender();
  });

  const back = body.querySelector("[data-back]");
  if (back) back.addEventListener("click", function () {
    MB_QUIZ_STATE.step -= 1;
    mbQuizRender();
  });

  const restart = body.querySelector("[data-restart]");
  if (restart) restart.addEventListener("click", function () {
    MB_QUIZ_STATE.band = "";
    MB_QUIZ_STATE.cup = "";
    MB_QUIZ_STATE.cupFit = "";
    MB_QUIZ_STATE.bandFit = "";
    MB_QUIZ_STATE.hooks = "";
    MB_QUIZ_STATE.step = 1;
    mbQuizRender();
  });

  const apply = body.querySelector("[data-apply]");
  if (apply) apply.addEventListener("click", function () {
    const result = mbQuizResolveSize();
    mbQuizClose();
    if (result) mbQuizApply(result);
  });
}

/* ---------- application au sélecteur existant ---------- */

/* Une offre est « visible » si elle occupe de la place à l'écran.
   Moon Bundle replie les offres non sélectionnées : leur liste
   déroulante ne s'ouvre pas, on ne peut donc pas les piloter. */
function mbOfferIsVisible(offer) {
  if (!offer || !offer.isConnected) return false;
  const rect = offer.getBoundingClientRect();
  return rect.width > 0 && rect.height > 0;
}

/* Remplit Tour de dos / Bonnet dans le panneau d'une offre, puis
   pousse la taille produit correspondante (BRA_SIZE_MAP) dans
   chaque liste Moon Bundle de cette offre. Renvoie true si chaque
   exemplaire affiche bien la bonne lettre à la fin. */
async function mbQuizApplyToUI(ui, band, cup) {
  const bandSelect = ui.querySelector(".mb-global-band");
  const cupSelect = ui.querySelector(".mb-global-cup");
  const errorEl = ui.querySelector(".mb-global-bra-error-wrap");
  const offer = ui.closest(".moonbundle-option-wrapper");
  if (!bandSelect || !cupSelect || !offer) return false;

  bandSelect.value = band;
  cupSelect.value = cup;

  /* Si un autre passage est encore en cours (choix manuel juste
     avant, ou l'offre précédente), on attend qu'il se termine au
     lieu d'être rejeté par le verrou isUpdating. */
  await waitFor(function () { return !isUpdating; }, 4000, 40);

  let ok = await applyMappedSizeToOffer(offer, band, cup, errorEl);

  /* Vérification indépendante : on relit ce que Moon Bundle affiche
     réellement, on ne se fie pas au retour seul. */
  const mapped = normalizeText(BRA_SIZE_MAP[band + cup] || "");
  const check = function () {
    const dropdowns = Array.from(
      offer.querySelectorAll(".mb-recommended-size-slot .moonbundle-custom-dropdown")
    );
    return dropdowns.length > 0 &&
      dropdowns.every(function (d) { return readMoonbundleDropdownValue(d) === mapped; });
  };

  if (!check()) {
    /* Moon Bundle a pu reconstruire la ligne après notre passage :
       on laisse retomber, puis on refait un tour complet. */
    await wait(350);
    await waitFor(function () { return !isUpdating; }, 4000, 40);
    ok = await applyMappedSizeToOffer(offer, band, cup, errorEl);
  }

  return ok && check();
}

async function mbQuizApply(result) {
  if (!result || !result.band || !result.cup) return;

  MB_QUIZ_APPLIED.band = result.band;
  MB_QUIZ_APPLIED.cup = result.cup;

  const uis = Array.from(document.querySelectorAll(".mb-global-bra-ui"));

  /* L'offre ouverte d'abord : c'est celle que la cliente regarde.
     Les offres repliées sont traitées ensuite si elles se laissent
     piloter, sinon elles seront remises à jour par
     mbQuizReapplyToFreshOffers quand Moon Bundle les affichera. */
  const visible = uis.filter(function (ui) {
    return mbOfferIsVisible(ui.closest(".moonbundle-option-wrapper"));
  });
  const hidden = uis.filter(function (ui) { return visible.indexOf(ui) === -1; });

  for (const ui of visible) {
    await mbQuizApplyToUI(ui, result.band, result.cup);
  }

  for (const ui of hidden) {
    const bandSelect = ui.querySelector(".mb-global-band");
    const cupSelect = ui.querySelector(".mb-global-cup");
    if (bandSelect) bandSelect.value = result.band;
    if (cupSelect) cupSelect.value = result.cup;
    ui.setAttribute("data-mb-pending", "1");
  }
}

/* Appelé à chaque rendu de Moon Bundle. Toute offre visible dont le
   panneau n'a pas encore reçu la taille choisie (nouvelle offre
   reconstruite, ou offre repliée au moment du quiz) la reçoit ici,
   une seule fois. */
let mbReapplyRunning = false;

async function mbQuizReapplyToFreshOffers() {
  if (!MB_QUIZ_APPLIED.band || !MB_QUIZ_APPLIED.cup) return;
  if (mbReapplyRunning || isUpdating) return;

  const uis = Array.from(document.querySelectorAll(".mb-global-bra-ui")).filter(function (ui) {
    const bandSelect = ui.querySelector(".mb-global-band");
    const cupSelect = ui.querySelector(".mb-global-cup");
    const fresh = bandSelect && cupSelect && (!bandSelect.value || !cupSelect.value);
    const pending = ui.getAttribute("data-mb-pending") === "1";
    return (fresh || pending) && mbOfferIsVisible(ui.closest(".moonbundle-option-wrapper"));
  });

  if (!uis.length) return;

  mbReapplyRunning = true;
  try {
    for (const ui of uis) {
      ui.removeAttribute("data-mb-pending");
      await mbQuizApplyToUI(ui, MB_QUIZ_APPLIED.band, MB_QUIZ_APPLIED.cup);
    }
  } finally {
    mbReapplyRunning = false;
  }
}

/* ---------- point d'entrée ---------- */

/* Remonte jusqu'au conteneur Moon Bundle le plus externe. */
function mbFindBundleRoot() {
  const offers = document.querySelectorAll(".moonbundle-option-wrapper");
  if (!offers.length) return null;

  let root = offers[0];
  while (
    root.parentElement &&
    typeof root.parentElement.className === "string" &&
    /moonbundle/i.test(root.parentElement.className)
  ) {
    root = root.parentElement;
  }

  return root;
}

/* Barre placée AU-DESSUS du widget Moon Bundle :
   le quiz à gauche, le guide des tailles à droite. */
function mbQuizInjectTrigger() {
  mbQuizInjectStyles();

  if (document.querySelector(".mb-quiz-bar")) return;

  const root = mbFindBundleRoot();
  if (!root || !root.parentElement) return;

  const bar = document.createElement("div");
  bar.className = "mb-quiz-bar";

  const quiz = document.createElement("button");
  quiz.type = "button";
  quiz.className = "mb-quiz-open";
  quiz.textContent = "Trouvez votre taille parfaite";
  quiz.addEventListener("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    mbQuizOpen();
  });

  const guide = document.createElement("button");
  guide.type = "button";
  guide.className = "mb-quiz-open mb-quiz-guide";
  guide.textContent = "Guide des tailles";
  guide.addEventListener("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
    injectSizeGuideModal();
    openSizeGuideModal(e);
  });

  bar.appendChild(quiz);
  bar.appendChild(guide);

  root.parentElement.insertBefore(bar, root);
}

/* mbQuizInjectTrigger() est déjà appelé depuis initGlobalBraSelectors,
   qui est relancé par l'observer à chaque rendu de Moon Bundle. */

/* ============================================================
   Celyssia — mise en page des prix des offres
   Haut : prix unitaire | total. Bas : les deux prix barrés.
   Tailles de texte : lignes « font-size » du CSS ci-dessous.
   ============================================================ */
(function () {
  const PRICE_RE = /^\s*\d[\d\s.,]*€\s*$/;
  const UNIT_RE = /€\s*\/\s*unité/i;

  function injectPriceStyles() {
    if (document.getElementById("cly-price-styles")) return;
    const style = document.createElement("style");
    style.id = "cly-price-styles";
    style.textContent = `
    .cly-price-box{
      display:grid !important;
      grid-template-columns:auto auto !important;
      column-gap:10px;row-gap:2px;
      justify-content:end;justify-items:end;align-items:baseline;
      flex-shrink:0 !important;
      min-width:max-content !important;
      margin-left:10px !important;
    }
    .cly-flat{display:contents !important;}
    .cly-unit{grid-area:1/1 !important;margin:0 !important;font-style:normal !important;white-space:nowrap;}
    .cly-total{grid-area:1/2 !important;margin:0 !important;white-space:nowrap;}
    .cly-compare-unit{grid-area:2/1 !important;margin:0 !important;text-decoration:line-through;white-space:nowrap;}
    .cly-compare{grid-area:2/2 !important;margin:0 !important;white-space:nowrap;}
    .cly-unit,.cly-total{font-size:16px !important;line-height:1.2 !important;}
    .cly-compare-unit,.cly-compare{font-size:12px !important;line-height:1.2 !important;}
    @media (max-width:480px){
      .cly-price-box{column-gap:6px;margin-left:6px !important;}
      .cly-unit,.cly-total{font-size:14px !important;}
      .cly-compare-unit,.cly-compare{font-size:11px !important;}
    }
    `;
    document.head.appendChild(style);
  }

  function num(el) {
    let t = el.textContent.replace(/[^\d.,]/g, "");
    if (t.indexOf(",") !== -1) t = t.replace(/\./g, "").replace(",", ".");
    return parseFloat(t);
  }

  /* Éléments les plus profonds dont le texte correspond au motif. */
  function deepest(root, re) {
    return Array.from(root.querySelectorAll("*")).filter(function (el) {
      if (el.classList.contains("cly-compare-unit")) return false;
      if (!re.test(el.textContent)) return false;
      return !Array.from(el.children).some(function (c) { return re.test(c.textContent); });
    });
  }

  function isStruck(el, stop) {
    for (let n = el; n && n !== stop; n = n.parentElement) {
      if (/^(S|DEL|STRIKE)$/.test(n.tagName)) return true;
      if (getComputedStyle(n).textDecorationLine.indexOf("line-through") !== -1) return true;
    }
    return false;
  }

  function layoutOffer(offer) {
    const unit = deepest(offer, UNIT_RE)[0];
    if (!unit) return; /* offre à l'unité : rien à faire */

    let box = unit.parentElement, total = null, compare = null;
    while (box && offer.contains(box)) {
      const prices = deepest(box, PRICE_RE).filter(function (p) { return !unit.contains(p); });
      total = prices.find(function (p) { return !isStruck(p, offer); });
      compare = prices.find(function (p) { return isStruck(p, offer); });
      if ((total && compare) || box === offer) break;
      box = box.parentElement;
    }
    if (!total || !compare) return;

    /* Chaque prix doit être un enfant direct de la grille. */
    let items = [];
    for (let i = 0; i < 6; i++) {
      items = [unit, total, compare].map(function (el) {
        let n = el;
        while (n.parentElement !== box && !n.parentElement.classList.contains("cly-flat")) n = n.parentElement;
        return n;
      });
      const shared = items.find(function (it, idx) { return items.indexOf(it) !== idx; });
      if (!shared) break;
      shared.classList.add("cly-flat");
    }

    box.classList.add("cly-price-box");
    items[0].classList.add("cly-unit");
    items[1].classList.add("cly-total");
    items[2].classList.add("cly-compare");

    const ts = getComputedStyle(total);
    items[0].style.fontWeight = ts.fontWeight;
    items[0].style.color = ts.color;

    const totalVal = num(total), unitVal = num(unit), compareVal = num(compare);
    if (!totalVal || !unitVal || !compareVal) return;
    const qty = Math.round(totalVal / unitVal);
    if (qty < 1) return;
    const text = (compareVal / qty).toFixed(2).replace(".", ",") + " €/unité";

    let el = box.querySelector(".cly-compare-unit");
    if (!el) {
      el = document.createElement("span");
      el.className = "cly-compare-unit";
      box.appendChild(el);
    }
    el.style.color = getComputedStyle(compare).color;
    if (el.textContent !== text) el.textContent = text;
  }

  function run() {
    injectPriceStyles();
    document.querySelectorAll(".moonbundle-option-wrapper").forEach(layoutOffer);
  }

  let timer = null;
  new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(run, 60);
  }).observe(document.body, { childList: true, subtree: true });

  run();
})();